import { Injectable } from '@angular/core';
import { AbstractControlOptions, FormArray, Validators } from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import {
  Parameters,
  PledgeProductRead,
} from '@app/forms/subscription/definition/interface/Pledge';
import { FormConfig } from '@app/forms/subscription/definition/types/subscription';
import FormGroupArray from '@app/forms/subscription/services/FormGroupArray';

@Injectable({
  providedIn: 'root',
})
export abstract class EaSubscriptionBuilder extends PrFormAbstract {
  generateForm(entity: PledgeProductRead & { parameters: any }, option) {
    const parameters: Parameters = {
      ...option,
    };
    let options: AbstractControlOptions = {};

    const formConfig: FormConfig<PledgeProductRead & { parameters: any }> = {
      id: [entity.id],
      type: [entity.type],
      productId: [entity.productId],
      productName: [entity.productName],
      status: [entity.status],
      parameters: this.formBuilder.group({
        // Hospitalisation
        hospitalisationHonorairesOptam: [entity?.parameters?.hospitalisationHonorairesOptam || null],
        hospitalisationHonorairesNonOptam: [entity?.parameters?.hospitalisationHonorairesNonOptam || null],
        hospitalisationChambreParticuliere: [entity?.parameters?.hospitalisationChambreParticuliere || null],
        hospitalisationPrimeMaternite: [entity?.parameters?.hospitalisationPrimeMaternite || null],
        // Optique
        optiqueLunettes: [entity?.parameters?.optiqueLunettes || null],
        optiqueLentilles: [entity?.parameters?.optiqueLentilles || null],
        optiquePlafond: [entity?.parameters?.optiquePlafond || null],
        optiqueChirurgieLaser: [entity?.parameters?.optiqueChirurgieLaser || null],
        // Dentaire
        dentaireProthese: [entity?.parameters?.dentaireProthese || null],
        dentaireOrthodontieAdulte: [entity?.parameters?.dentaireOrthodontieAdulte || null],
        dentaireOrthodontieEnfant: [entity?.parameters?.dentaireOrthodontieEnfant || null],
        // Pharmacie
        pharmaciePriseEnCharge: [entity?.parameters?.pharmaciePriseEnCharge || null],
        // Medecines douces
        medecinesDouces: [entity?.parameters?.medecinesDouces || null],
        // Consultations
        consultationsOptamCas: [entity?.parameters?.consultationsOptamCas || null],
        consultationsNonOptamNonCas: [entity?.parameters?.consultationsNonOptamNonCas || null],
        // Cotisations
        cotisationsMontant: [entity?.parameters?.cotisationsMontant || null],
        // Commentaire
        commentaire: [entity?.parameters?.commentaire || null],
      }),
    };

    return this.formBuilder.group(formConfig, options);
  }
  generate(entity: any, option) {
    return FormGroupArray.generate({
      entity,
      options: option,
      formBuilder: this.formBuilder,
      generateForm: this.generateForm.bind(this),
      propertyName: 'products',
    });
  }

  get products() {
    return this.form.get('products') as FormArray;
  }

  extract() {
    return this.form.value.products;
  }
}
